import { useNavigate } from 'react-router-dom';
import Typography from '../Typography/Typography';
import styles from './style.module.css';
import { exportIcon, filter, plusWhite, searchIcon } from '../../assets/svgs';
import { FilterDropdown, FilterCategory } from "../TreeSelector";
import { useState } from 'react';

export interface Column<T> {
  title: React.ReactNode;
  key: keyof T;
}

interface TableProp<T extends { id?: string | number }> {
  header: Column<T>[];
  data: T[];
  className?: string;
  route?: string;
  searchFor?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  filters?: FilterCategory[];
  pageSize?: number; // 🔹 new: control how many items per page
  addModal: () => void
  addBtn?: boolean
  // id?: string
  orderModal?: (id: string) => void
}

export const SellerTable = <T extends { id?: string | number }>({
  header,
  data,
  className,
  route,
  searchFor,
  onChange,
  filters,
  pageSize = 8, // default 8 like screenshot
  addModal,
  addBtn = false,
  // id,
  orderModal,
}: TableProp<T>) => {

  const [filterToggle, setfilterToggle] = useState(false)
  const [currentPage, setCurrentPage] = useState(1); // 🔹 pagination state
  const navigate = useNavigate()

  const routing = (id: string) => {
    if (route) {
      navigate(`${route}/${id}`)
    } else {
      return ""
    }
  }

  const handleOrderModal = (id: string) => {
    if (orderModal) {
      orderModal(id)
    } else {
      return ""
    }
  }

  // const handleId = () => {
  //   const
  // }

  const handleFilterChange = (selected: string[]) => {
    console.log("Selected Filters:", selected);
  };

  // 🔹 Pagination logic
  const totalPages = Math.ceil(data.length / pageSize);
  const startIdx = (currentPage - 1) * pageSize;
  const endIdx = startIdx + pageSize;
  const paginatedData = data.slice(startIdx, endIdx);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // 🔹 Updated pagination logic from the React component
  const getPaginationNumbers = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else if (totalPages > 1) {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  return (
    <div className={`${styles.tableContainer}${className ? " " + className : ""}`}>
      <div>

        <div className={styles.tableTop}>

          <div className={styles.searchContainer}>
            <img src={searchIcon} alt="" />
            <input
              type="text"
              placeholder='Search'
              value={searchFor}
              onChange={onChange}
            />
          </div>

          <div className={styles.filterContainer}>
            <button
            title='Toggle button'
              className={styles.btnIcon}
              onClick={() => { setfilterToggle(!filterToggle) }}
            >
              <img src={filter} alt="" />
            </button>

            {filterToggle && filters && (
              <div className={styles.filterDropdown}>
                <FilterDropdown
                  categories={filters}
                  onChange={handleFilterChange}
                />
              </div>
            )}
          </div>

          <button title='Export Button' className={styles.btnIcon}>
            <img src={exportIcon} alt="Export icon" />
          </button>

          {addBtn && (
            <button
              className={styles.addBtn}
              onClick={() => { addModal() }}
            >
              <img src={plusWhite} alt="" />
              <Typography className={styles.addText}>
                Add Product
              </Typography>
            </button>
          )}

        </div>

      </div>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              {header.map((col) => (
                <th key={String(col.key)}>
                  <Typography className={styles.headerText}>
                    {col.title}
                  </Typography>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {paginatedData.map((item) => (
              <tr
                key={item.id}
                className={styles.navRow}
              >
                {header.map((col) => (
                  <td
                    key={String(col.key)}
                    onClick={() => {
                      routing(`${item.id}`)
                      if (col.key !== "status") {
                        handleOrderModal(`${item.id}`);
                      }
                    }}
                  >
                    <Typography className={styles.bodyText}>
                      {col.key === "id" ? `#${item[col.key]}` : item[col.key] as React.ReactNode}
                    </Typography>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 🔹 Pagination Footer with updated logic */}
      <div className={styles.paginationContainer}>
        <Typography className={styles.resultText}>
          Result {startIdx + 1}-{Math.min(endIdx, data.length)} of {data.length}
        </Typography>

        <div className={styles.paginationButtons}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`${styles.pageBtn} ${styles.activePage}`}
          >
            &lt;
          </button>

          {getPaginationNumbers().map((page, idx) =>
            page === "..." ? (
              <span key={idx} className={styles.ellipsis}>...</span>
            ) : (
              <button
                key={page}
                onClick={() => handlePageChange(Number(page))}
                className={`${styles.pageBtn} ${currentPage === page ? styles.activePage : ""}`}
              >
                {page}
              </button>
            )
          )}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`${styles.pageBtn} ${styles.activePage}`}
          >
            &gt;
          </button>
        </div>
      </div>
    </div>
  );
};